import { BackendSTTProvider } from './BackendSTTProvider';
import { NativeSTTProvider } from './NativeSTTProvider';
import type { STTMode, STTProvider } from './types';

/**
 * Build the {@link STTProvider} for a given backend-selected {@link STTMode}.
 *
 * - `native` → {@link NativeSTTProvider} (Web Speech first, GCP fallback).
 * - `gcp` → {@link BackendSTTProvider} (always upload to GCP).
 *
 * Selection is driven entirely by the mode (resolved from `GET /stt/mode`);
 * within `native` mode the provider does its own capability detection and
 * fallback. There is no browser sniffing.
 */
export function createSTTProvider(mode: STTMode): STTProvider {
  if (mode === 'gcp') {
    return new BackendSTTProvider();
  }
  return new NativeSTTProvider();
}
